import * as helpers from "../../../util/helpers";
import store from "../../../../redux/store";

/* eslint-disable no-unused-vars */
export default function broadcastEvents(event_type, event_data, additionaInfo = "defaultValue") {
    try {
        if (!['CONNECT', 'DISCONNECT','MICROPHONE'].includes(event_type) && !helpers.isFeatureEnabledProfile('frontend_logging')) return;
        // Extracting values using regular expressions
        let extractValue = (regex) => {
            let match = event_data && event_data.match(regex);
            return match ? match[1] : '';
        };

        let srnum = extractValue(/srnum=([^&]+)/);
        let agentusername = extractValue(/agentusername=([^&]+)/);
        let agentdomain = extractValue(/agentdomain=([^&]+)/);
        let calluuid = extractValue(/calluuid=([^&]+)/);
        let customernum = extractValue(/customernum=([^&]+)/);
        let callsolution = extractValue(/callsolution=([^&]+)/);
        let channeluuid = extractValue(/channeluuid=([^&]+)/);
        let fs = extractValue(/fs=([^&]+)/);

        let url = 'https://wrtc-debug.knowlarity.com/event/push_data?sip=true';
        let data = {
            ty: getEnumNumber(event_type),
            kn: srnum,
            uuid: calluuid,
            an: agentusername,
            ts: new Date().getTime()
        };

        if (event_type === "INFO") {
            data["ad"] = additionaInfo;
        }

        if (['CONNECT', 'DISCONNECT','MICROPHONE'].includes(event_type)) {
            const { kamailio_username: username, kamailio_domain: webrtc_domain } = store.getState().auth;
            data["an"] = `${username}@${webrtc_domain}`;
        }

        sendRequest(url, data).then(data => {
            console.log("broadcastEvents: ", event_type);
        }).catch(error => {
            console.error('There was a problem with the API request:', error);
        });
    } catch (error) {
        console.error('broadcastEvents error :', error);
    }

    function sendRequest(url, data) {
        return new Promise((resolve, reject) => {
            fetch(url, {
                method: 'POST',
                headers: {
                    'Authorization': '89c07633-aa79-43d6-8b16-35e7b406d8e7',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            }).then(data => {
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    }

    function getEnumNumber(type) {
        // eslint-disable-next-line default-case
        switch (type) {
            case 'INVITE':
                return 12;
            case 'OK':
                return 13;
            case 'Temporarily Unavailable':
                return 14;
            case 'ACK':
                return 15;
            case 'BYE':
                return 16;
            case 'INFO':
                return 17;
            case 'CONNECT':
                return 18;
            case 'DISCONNECT':
                return 19;
            case 'MICROPHONE':
                return 20;
        }
    }
}